<div class="flex full-width items-center">
  <mat-form-field class="date-picker-width {{customCssClasses ? customCssClasses.join(' ') : ''}}" [formGroup]="dateForm">
    <mat-label>{{label}}</mat-label>
    <input matInput
           formControlName="date"
           [min]="minDate"
           [max]="maxDate"
           [placeholder]="placeholder"
           [required]="required"
           [attr.data-qa]="qaAttr"
           [attr.data-element]="'qa-element-date-picker'"
           [matDatepicker]="picker"
           (dateChange)="onDateChange($event)">
    <mat-datepicker-toggle matIconSuffix [for]="picker">
    </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
    <mat-error>{{getErrorMessage()}}</mat-error>
  </mat-form-field>
  
  <ng-container *ngIf="showInfoIcon">
    <mat-icon class="info-icon" [matTooltip]="tooltip">help_outline</mat-icon>
  </ng-container>
</div>
